import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { vacationApplicationApi, VacationApplicationResponse } from 'app/services/edpApiV1/vacationApplication';
import { RootState } from 'app/store';

const initialState: VacationApplicationResponse = {
  data: null,
  pagination: null,
};

export const vacationsApplicationSlice = createSlice({
  name: 'vacations',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        vacationApplicationApi.endpoints.vacationsApplicationVA.matchFulfilled,
        (state, { payload }: PayloadAction<VacationApplicationResponse>) => payload,
      )
      .addMatcher(vacationApplicationApi.endpoints.vacationsApplicationVA.matchRejected, () => initialState);
  },
});

const vacations = (state: RootState) => state.entities.vacations;
const getVacations = createSelector(vacations, state => state);

export const selectors = { getVacations };
export const actions = vacationsApplicationSlice.actions;
export const reducer = vacationsApplicationSlice.reducer;
